import { useState } from "react";
import { Building2, HelpCircle, Mail, ShieldAlert, User } from "lucide-react";
import { Header } from "@/components/Header";
import { EmailPrefs } from "@/components/EmailPrefs";
import { HelpCenter } from "@/components/HelpCenter";
import { DeleteAccount } from "@/components/DeleteAccount";
import { BankAccounts } from "@/components/BankAccounts";
import { useAuth } from "@/context/AuthContext";

const SECTIONS = [
  { k: "profile", l: "Profile", I: User },
  { k: "bank", l: "Bank accounts", I: Building2 },
  { k: "email", l: "Email preferences", I: Mail },
  { k: "help", l: "Help center", I: HelpCircle },
  { k: "danger", l: "Delete account", I: ShieldAlert },
];

const Profile = () => {
  const { user } = useAuth();
  return (
    <div className="flex items-center gap-4" data-testid="settings-profile">
      {user?.picture ? <img src={user.picture} alt="" className="h-14 w-14 rounded-full border border-[#212638]" /> :
        <div className="grid h-14 w-14 place-items-center rounded-full bg-[#F7931A] font-display text-xl font-bold text-[#08090E]">{user?.name?.[0]}</div>}
      <div>
        <p className="font-semibold" data-testid="settings-profile-name">{user?.name}</p>
        <p className="text-sm text-[#94A3B8]" data-testid="settings-profile-email">{user?.email}</p>
        <p className="mt-1 text-xs text-[#64748B]">Signed in with Google{user?.is_admin ? " · Admin" : ""}</p>
      </div>
    </div>
  );
};

const BODY = { profile: Profile, bank: BankAccounts, email: EmailPrefs, help: HelpCenter, danger: DeleteAccount };

export default function SettingsPage() {
  const [tab, setTab] = useState("profile");
  const Body = BODY[tab];
  const cur = SECTIONS.find((s) => s.k === tab);
  return (
    <div className="grain min-h-screen bg-[#08090E]">
      <Header />
      <main className="relative z-10 mx-auto max-w-5xl px-4 pb-16 pt-24 md:px-8 md:pt-28">
        <h1 className="fade-up mb-6 text-3xl font-bold tracking-tight sm:text-4xl">Settings</h1>
        <div className="grid gap-6 md:grid-cols-[220px_1fr]">
          <nav className="flex gap-1 overflow-x-auto md:flex-col" data-testid="settings-nav">
            {SECTIONS.map(({ k, l, I }) => (
              <button key={k} onClick={() => setTab(k)} data-testid={`settings-tab-${k}`}
                className={`flex shrink-0 items-center gap-2 rounded-xl px-3 py-2.5 text-left text-sm font-semibold transition-colors ${tab === k ? (k === "danger" ? "bg-red-500/10 text-red-400" : "bg-[#151824] text-[#F7931A]") : "text-[#94A3B8] hover:bg-[#151824] hover:text-white"}`}>
                <I size={15} /> {l}
              </button>
            ))}
          </nav>
          <section className="card fade-up p-5 md:p-6" key={tab}>
            <h2 className={`mb-4 text-lg font-semibold tracking-tight ${tab === "danger" ? "text-red-400" : ""}`}>{cur.l}</h2>
            <Body />
          </section>
        </div>
      </main>
    </div>
  );
}
